import o, { useState as x } from "react";
import { c as l } from "./app-a75c1d35.mjs";
import { u as M } from "./useClickOutside-726e7c36.mjs";
import { L as O } from "./LinkPreviewCard-2daafeaa.mjs";
import { B as a } from "./Block-9b78bd10.mjs";
import { B as R } from "./Button-c598cb52.mjs";
import "./Image-d6406817.mjs";
import "./ImageContext-57256dc1.mjs";
import "./Image.module-8b345b58.mjs";
import "./Link-479ac100.mjs";
import "./LinkContext-0c83848a.mjs";
import "./CallToAction-d24a74ed.mjs";
import "./Icon-3122c134.mjs";
const H = "lp-container--bg-auto", D = "lp-container__employer", G = "lp-container__content", W = "desktop", j = "lp-container__content-no-images", q = "lp-container", z = "button-container", t = {
  lpContainerBgAuto: H,
  lpContainerEmployer: D,
  lpContainerContent: G,
  desktop: W,
  lpContainerContentNoImages: j,
  lpContainer: q,
  buttonContainer: z
}, F = 5;
function at(c) {
  const {
    cards: n,
    hasImages: e,
    hasSaveButton: p,
    newTab: m,
    backgroundColor: C = "auto",
    ...d
  } = c, [r, u] = x(3), g = M();
  if (!n.length)
    return null;
  const b = () => {
    r >= n.length || u((i) => i + F);
  }, S = l(
    t.lpContainerContent,
    e ? "" : t.lpContainerContentNoImages
  ), h = n.slice(0, r), k = e ? n : h;
  return /* @__PURE__ */ o.createElement(
    a,
    {
      topPadding: a.Padding.NONE,
      bottomPadding: a.Padding.LARGE,
      className: l(
        t.lpContainer,
        g && t.lpContainerEmployer,
        C === "auto" && t.lpContainerBgAuto
      ),
      ...d
    },
    /* @__PURE__ */ o.createElement(a.Content, { className: S }, k.map((i, E) => {
      const {
        cardIntroText: w,
        cardTitle: B,
        imageProps: T,
        link: s,
        linkLabel: f,
        linkLocale: N,
        linkDescription: _,
        isSaved: v,
        onSave: y,
        showCTAOnMobile: P,
        newTab: I,
        hasSaveButton: L,
        badge: A
      } = i;
      return /* @__PURE__ */ o.createElement(
        O,
        {
          key: s + E,
          cardIntroText: w,
          cardTitle: B,
          imageProps: T,
          link: s,
          linkDescription: _,
          linkLocale: N,
          hasImages: e,
          hasSaveButton: L || p,
          linkLabel: f,
          isSaved: v,
          onSave: y,
          newTab: I || m,
          showCTAOnMobile: P,
          badge: A
        }
      );
    })),
    !e && r < n.length && /* @__PURE__ */ o.createElement("div", { className: t.buttonContainer }, /* @__PURE__ */ o.createElement(
      R.Secondary,
      {
        text: "Show more",
        onClick: b
      },
      "show more"
    ))
  );
}
export {
  at as LinkPreview,
  O as LinkPreviewCard
};
//# sourceMappingURL=LinkPreview.js.map
